export default __webpack_public_path__ + "static/naves_2-64d81c1274addaf57965b03e429feb43.jpg";